import { NativeStackScreenProps } from '@react-navigation/native-stack';
import React from 'react';

import BlockListModal from '../Components/Social/BlockListModal';
import { RootStackParamList } from '../navigator';

type Props = NativeStackScreenProps<RootStackParamList, 'BlockList'>;

const BlockListScreen: React.FC<Props> = ({ navigation }) => (
	<BlockListModal
		onClose={() => {
			if (navigation.canGoBack()) {
				navigation.goBack();
			} else {
				navigation.navigate('Main');
			}
		}}
	/>
);

export default BlockListScreen;
